import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/village/meteo',
            name: 'village_meteo',
            component: () => import("./views/meteo.vue"),
            meta: {
                hideTopCut: true,
                showMembership: true,
            }
        },
    ];
};